"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.convertArrayToCSV = void 0;

var _checkIfValid = require("./helpers/check-if-valid");

var _convertArrayOfArraysToCsv = require("./modules/convert-array-of-arrays-to-csv");

var _convertArrayOfObjectsToCsv = require("./modules/convert-array-of-objects-to-csv");

var convertArrayToCSV = function convertArrayToCSV(data) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      header = _ref.header,
      separator = _ref.separator;

  (0, _checkIfValid.checkIfValid)(data);
  var thisOptions = {
    header: header,
    separator: separator || ','
  };

  if (Array.isArray(data[0])) {
    return (0, _convertArrayOfArraysToCsv.convertArrayOfArraysToCSV)(data, thisOptions);
  }

  return (0, _convertArrayOfObjectsToCsv.convertArrayOfObjectsToCSV)(data, thisOptions);
};

exports.convertArrayToCSV = convertArrayToCSV;
var _default = convertArrayToCSV;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/convert-array-to-csv/lib/index.js
// module id = 77
// module chunks = 0